<template>
    <div
        class="cigarette"
        :style="{ paddingTop: routeName === 'cigarette' ? '16px' : 0 }"
        v-if="$route.meta.showCigarette"
    >
        <a-breadcrumb separator=">" v-if="routeName !== 'cigarette'">
            <a-breadcrumb-item
                ><router-link to="/cigarette"
                    ><img
                        src="../../assets/cigarette/电子烟专区-蓝.svg"
                        style="margin: 0 4px 4px 0"
                    />电子烟专区</router-link
                ></a-breadcrumb-item
            >
            <a-breadcrumb-item v-if="routeName === 'cigarette-entrust'">委托查询</a-breadcrumb-item>
            <a-breadcrumb-item v-if="routeName === 'cigarette-guidelines'">办事指南</a-breadcrumb-item>
        </a-breadcrumb>
        <div class="left">
            <submenu-tabs
                ref="subTabs"
                :title="title"
                :tabs="submenuTabs"
                :propActive="propActive"
                @changeTab="changeTab"
            ></submenu-tabs>
            <div class="online-delegation">
                <button @click="delegation">立即委托</button>
            </div>
        </div>
        <div class="right">
            <router-view></router-view>
        </div>
    </div>

    <router-view v-else></router-view>
</template>

<script>
import SubmenuTabs from '../../components/submenu-tabs.vue';
import { mapMutations ,mapActions} from 'vuex';

export default {
    components: { SubmenuTabs },
    data() {
        return {
            title: '电子烟专区',
            propActive: '',
            submenuTabs: [
                { id: 'cigarette-entrust', name: '委托查询' },
                { id: 'cigarette-guidelines', name: '办事指南' }
            ]
        };
    },

    watch: {
        routeName: {
            immediate: true,
            handler(name) {
                this.propActive = this.submenuTabs.find(s => s.id == name)?.name;
            }
        }
    },

    computed: {
        routeName() {
            return this.$route.name;
        }
    },

    created() {
        this.getHideFields();
    },

    methods: {
        ...mapMutations(['changeSpinning']),
        ...mapActions('testService', [
            'createOnlineFolders',
            'getHideFields',
        ]),
        changeTab(tab) {
            this.$router.push({ name: tab.id });
        },

        async delegation() {
                this.changeSpinning(true);
                const folderId = (await this.createOnlineFolders()).data;
                const params = {
                    folderId
                };
                this.$router.push({ name: 'cigarette-online-delegation', query: params });
                this.changeSpinning(false);
        }
    }
};
</script>
<style lang="scss" scoped>
.cigarette {
    width: 1200px;
    padding: 0 0 94px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .left {
        width: 292px;

        .online-delegation {
            margin-top: 16px;
            width: 292px;
            height: 392px;
            background: url(../../assets/cigarette/在线委托-电子烟.png) no-repeat;
            background-size: 100% 100%;

            button {
                background: transparent;
                border: 1px solid rgba(255, 255, 255, 1);
                border-radius: 4px;
                font-size: 18px;
                color: #ffffff;
                margin-top: 100px;
                margin-left: 32px;
                width: 104px;
                height: 32px;
                cursor: pointer;
            }
        }
    }

    .right {
        width: 892px;
    }
}
</style>
